import Box from "@mui/material/Box";
import {CircularProgress, Table, TableBody, TableCell, TableRow} from "@mui/material";
import Typography from "@mui/material/Typography";
import {useParams} from "react-router";
import useSuggestionRepository from "../../../../../repository/assignment/useSuggestionRepository";
import {useEffect, useState} from "react";
import isNull from "../../../../../mixin/isNull";
import useDefaultItemRepository from "../../../../../repository/emergency/useDefaultItemRepository";
import useInterventionRepository from "../../../../../repository/emergency/useInterventionRepository";
import useHelper from "../../../../../use/useHelper";

export default function () {
    const helper = useHelper();
    const {token} = useParams();
    const suggestionRepository = useSuggestionRepository();
    const interventionRepository = useInterventionRepository();
    const defaultItemRepository = useDefaultItemRepository();
    /** @type Suggestion */
    const suggestion = suggestionRepository.findOneByToken(token).select();
    const [supportedPriceItems, setSupportedPriceItems] = useState(null);

    useEffect(() => {
        suggestionRepository.findOneByToken(token).exec();
        defaultItemRepository.findAll().exec();
    }, []);

    useEffect(() => {
        if (isNull(suggestion)) return;

        fetchSupportedPrice();
    }, [JSON.stringify(suggestion)]);

    const fetchSupportedPrice = async () => setSupportedPriceItems((await interventionRepository.getSupportedPriceByOrder(suggestion.getOrderId())));


    if (isNull(supportedPriceItems)) {
        return (
            <Box display="flex" justifyContent={"center"} mt={5}>
                <CircularProgress/>
            </Box>
        )
    }

    return (
        <Box>
            <Table size={"small"}>
                <TableBody>
                    {
                        supportedPriceItems.map(spi => (
                            <TableRow key={spi.default_item_id}>
                                <TableCell>
                                    {spi.name}
                                </TableCell>
                                <TableCell>
                                    {helper.priceFormatter(spi.price)} € H.T.
                                </TableCell>
                            </TableRow>
                        ))
                    }
                </TableBody>
            </Table>

            <Typography mt={3} fontSize="small" color="warning" textAlign="center">
                Le non-respect des procédures entraînera des pénalités.
            </Typography>
        </Box>
    )
}